// THIS FILE IS AUTOMATICALLY GENERATED. DO NOT MODIFY IT.

export { MiscColorWheelIcon } from './MiscColorWheelIcon';
